import { render, staticRenderFns } from "./filePreview.vue?vue&type=template&id=98cd5836&scoped=true"
import script from "./filePreview.vue?vue&type=script&lang=js"
export * from "./filePreview.vue?vue&type=script&lang=js"
import style0 from "./filePreview.vue?vue&type=style&index=0&id=98cd5836&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cd5836",
  null
  
)

export default component.exports